import { z } from 'zod';

import { insuranceDataSchema } from './schemas';

export type InsuranceDataSchema = z.infer<typeof insuranceDataSchema>;

export enum InsuranceTabKeys {
  MANUAL = 'manual',
  ORDER = 'order',
}
